// utils/auth.js
import { API_BASE } from "../../../config/config";

function safeReturnTo(raw) {
  try {
    if (!raw) return '/login';
    const u = new URL(raw, window.location.origin);
    if (u.origin !== window.location.origin) return '/login';
    return u.pathname + u.search + u.hash;
  } catch {
    return '/login';
  }
}

export function login(returnTo) {
  const dest = typeof returnTo === "string" && returnTo ? safeReturnTo(returnTo) : '/login';
  window.location.assign(`${API_BASE}/api/auth/login?returnTo=${encodeURIComponent(dest)}`);
}

// Logout: Call backend logout endpoint and redirect to signed-out page
export async function logout() {
  const finalLanding = `${window.location.origin}/signed-out`;
  try {
    await fetch(`${API_BASE}/api/auth/logout`, {
      credentials: "include",
      method: "POST",
      cache: "no-store"
    });
  } catch {}
  try {
    sessionStorage.clear();
    localStorage.removeItem("sessionStartMs");
    localStorage.removeItem("appDeploymentId");
  } catch {}
  window.location.replace(finalLanding);
}

// Get current user info from backend
export async function getMe() {
  const res = await fetch(`${API_BASE}/api/me`, {
    credentials: "include",
    cache: "no-store",
  });
  if (!res.ok) throw new Error(String(res.status));
  return res.json();
}
